var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './PeriscopeFieldGroup.scss';
import { PeriscopeFieldRow } from './PeriscopeFieldRow';
import React from 'react';
export const PeriscopeFieldGroup = (_a) => {
    var { group } = _a, rest = __rest(_a, ["group"]);
    return React.createElement("div", { className: 'periscope-field-group' },
        React.createElement("span", null, group.name),
        React.createElement("div", { className: 'periscope-field-list' }, group.fields.map((field, index) => React.createElement(PeriscopeFieldRow, Object.assign({ field: field, 
            // eslint-disable-next-line react/no-array-index-key
            key: `${field.sonarObjectId}-${index}` }, rest)))));
};
